export const HASH_SCROLL_MARGIN_PX = 96;

export const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const hashId = (hash) => (hash || '').replace(/^#/, '');

export const resolveHashTarget = (hash, root = typeof document !== 'undefined' ? document : null) => {
  if (!root) {
    return null;
  }

  const id = hashId(hash);
  if (!id) {
    return null;
  }

  const heading = root.getElementById(`${id}-heading`);
  if (heading) {
    return heading;
  }

  const section = root.getElementById(id);
  if (!section) {
    return null;
  }

  return section.querySelector('h1, h2, h3, h4, h5, h6') || section;
};

export const ensureFocusable = (element) => {
  if (!element) {
    return;
  }
  if (!element.hasAttribute('tabindex')) {
    element.tabIndex = -1;
  }
};

export const focusHashTarget = (target) => {
  if (!target) {
    return;
  }

  ensureFocusable(target);
  const behavior = prefersReducedMotion() ? 'auto' : 'smooth';
  target.scrollIntoView({ behavior, block: 'start' });
  target.focus({ preventScroll: true });
};

export const navigateToHash = (hash, root) => {
  const target = resolveHashTarget(hash, root);
  if (!target) {
    return null;
  }
  focusHashTarget(target);
  return target;
};
